/**
 * Generated by orval. Do not edit manually.
 */

export type AnnouncementLogActionChoice =
  (typeof AnnouncementLogActionChoice)[keyof typeof AnnouncementLogActionChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementLogActionChoice = {
  created: 'created',
  changed: 'changed',
  deleted: 'deleted',
} as const
